import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { BsModalRef, BsModalService } from 'ngx-bootstrap';

import { DynamicFormCommonConfig } from 'zr-dynamic-form/dynamic-form-common';
import {
  ShowHiddenRuleModel,
  showHiddenRuleTypes,
  showHiddenOperators,
  ShowHiddenCondition,
  showHiddenSatisfyShowTypes
} from '../../../types/control-show-hidden.types';

import { DynamicForm } from '../../../types';

import { isShowConditionValue } from '../show-hidden.util';
import { ShowHiddenUiComponent } from '../show-hidden-ui/show-hidden-ui.component';

@Component({
  selector: 'df-show-hidden-list',
  templateUrl: './show-hidden-list.component.html',
  styleUrls: ['./show-hidden-list.component.scss']
})
export class ShowHiddenListComponent implements OnInit {
  @Input() ruleModels: ShowHiddenRuleModel[] = [];
  @Output() ruleModelChange: EventEmitter<ShowHiddenRuleModel[]> = new EventEmitter<ShowHiddenRuleModel[]>();

  dynamicForm: DynamicForm;

  constructor(
    public activeModal: BsModalRef,
    private bsModalService: BsModalService,
    private commonConfig: DynamicFormCommonConfig
  ) {}

  ngOnInit() {}

  add() {
    if (this.ruleModels.length >= 100) {
      this.commonConfig.log.warn('ä¸ä¸ªè¡¨åæå¤å¯è®¾ç½®100ä¸ªæ¾éè§å');
      return;
    }

    const component = this.bsModalService.show(ShowHiddenUiComponent, {
      ignoreBackdropClick: true,
      class: `modal-lg`,
      initialState: { title: 'æ·»å ', dynamicForm: this.dynamicForm, showHiddenRuleModels: this.ruleModels }
    }).content as ShowHiddenUiComponent;

    component.modelChange.subscribe((s: ShowHiddenRuleModel) => {
      this.ruleModels.unshift(s);
    });
  }

  edit(model: ShowHiddenRuleModel, i: number) {
    const component = this.bsModalService.show(ShowHiddenUiComponent, {
      ignoreBackdropClick: true,
      class: `modal-lg`,
      initialState: {
        title: 'ç¼è¾',
        showHiddenRuleModel: model,
        showHiddenRuleModels: this.ruleModels,
        dynamicForm: this.dynamicForm
      }
    }).content as ShowHiddenUiComponent;

    component.modelChange.subscribe((s: ShowHiddenRuleModel) => {
      this.ruleModels[i] = s;
    });
  }

  delete(rule: ShowHiddenRuleModel) {
    this.commonConfig.dialog.confirm('ç¡®å®å é¤æ­¤æ¾éè§åï¼').subscribe(
      () => {
        this.ruleModels = this.ruleModels.filter((r) => r !== rule);
        this.ruleModelChange.emit(this.ruleModels);
      },
      () => {}
    );
  }

  getShowHiddenSatisfyTypes(model: ShowHiddenRuleModel) {
    const type = showHiddenSatisfyShowTypes.find((s) => s.value === model.showHiddenSatisfyType);
    return type ? type.text : '';
  }

  getShowHiddenRuleTypeText(model: ShowHiddenRuleModel) {
    const type = showHiddenRuleTypes.find((s) => s.value === model.showHiddenRuleType);
    return type ? type.text : '';
  }

  getTargetControlNames(model: ShowHiddenRuleModel) {
    return model.targetControlsName.join(',');
  }

  getOpText(op: string) {
    const type = showHiddenOperators.find((s) => s.value === op);
    return type ? type.text : '';
  }

  isShowConditionValue(condition: ShowHiddenCondition) {
    return isShowConditionValue(condition);
  }
}
